/**
 * @file Progress.tsx
 * Exports a component that renders a progress bar.
 */
import React from 'react';
import { ProgressIndicator, ProgressStep } from 'carbon-components-react';
import './_progress.scss';

type ProgressProps = {
  current: number;
};

const Progress = ({ current }: ProgressProps) => {
  return (
    <div className="watsonxsa_widget">
      <div className="progress-bar">
        <ProgressIndicator currentIndex={current}>
          <ProgressStep label="" />
          <ProgressStep label="" />
          <ProgressStep label="" />
          <ProgressStep label="" />
          <ProgressStep label="" />
          <ProgressStep label="" />
          <ProgressStep label="" />
        </ProgressIndicator>
      </div>
    </div>
  );
};

export default Progress;
